// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__19xuF","mobile":"Header_mobile__39HCi","desktop":"Header_desktop__291XD"};